export enum PurchaseOrderDepartment {
  Procurement = 'procurement',
  Tracking = 'tracking',
  Parts = 'parts',
}
